__turbopack_context__.v({
  "sidebar-navigation__content": "_4SD0ha_sidebar-navigation__content",
  "sidebar-navigation__content--open": "_4SD0ha_sidebar-navigation__content--open",
  "sidebar-navigation__headline": "_4SD0ha_sidebar-navigation__headline",
  "sidebar-navigation__toggle": "_4SD0ha_sidebar-navigation__toggle",
});
